export enum ReferenceSections {
    MyGeotab = "MYG",
    MyAdmin = "MYA",
    Drive = "Drive"
}